import Reordinator from "./reordinator";

let reordinator = null;

const attach = () => {
  const infoPostTable = document.querySelector("#info_post_table");
  if (infoPostTable) {
    reordinator = new Reordinator(
      infoPostTable,
      document.querySelector("#reorder_button"),
      document.querySelector("#reorder_alert"),
      [".deactivate_button", ".discard_button"],
      (serializedItem, sortableContainer) => {
        // console.log(serializedItem);
        return {
          id: serializedItem.node.dataset.id,
          position: serializedItem.index + 1,
        };
      },
      (i) => parseInt(i.id),
      (data) => {
        const token = document.querySelector("[name=csrf-token]").content;
        fetch(document.querySelector("[data-url]").dataset.url, {
          method: "PATCH",
          body: JSON.stringify({ info_post_ids: data }),
          headers: {
            "X-CSRF-TOKEN": token,
            "Content-Type": "application/json",
          },
        })
          .then((res) => res.json())
          .then((res) => {
            const { message, info_posts } = res;
            if (info_posts) {
              reordinator.setOrderings(info_posts);
            }

            if (message) {
              if (info_posts) {
                reordinator.setAlertMessage("success", message);
              } else {
                reordinator.setAlertMessage("failed", message);
              }
            }
          })
          .finally(reordinator.returnToDefaultState);
      }
    );

    reordinator.attach();
  }
};

const detach = () => {
  if (reordinator) {
    reordinator.detach();
    reordinator = null;
  }
};

document.addEventListener("turbo:load", attach);
document.addEventListener("turbo:before-cache", detach);
document.addEventListener("turbo:before-render", detach);
